var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { space } from 'styled-system';
import { css, styled } from "../../utils";
var SuggestionsContainer = styled.ul(function (_a) {
    var space = _a.theme.space;
    return "\n  display: flex;\n  height: 45px;\n  justify-content: flex-start;\n  align-items: center;\n  margin: ".concat(space[1], " 0px 0px 0px;\n  gap: 8px;\n  flex-wrap: wrap;\n  overflow: hidden;\n  text-wrap: wrap;\n");
});
var StyledWrapper = styled.li(function (_a) {
    var _b = _a.theme, space = _b.space, radii = _b.radii, colors = _b.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-radius: ", "px;\n    box-shadow: -1px 2px 2px 0px #00000040;\n    box-sizing: border-box;\n    margin-left: ", ";\n    padding: 0.3rem ", ";\n    text-overflow: ellipsis;\n    text-align: center;\n    overflow: hidden;\n    text-wrap: nowrap;\n    display: inline-block;\n    background: ", ";\n    &:hover {\n      background: ", ";\n      color: ", ";\n      box-shadow: unset;\n      cursor: pointer;\n    }\n  "], ["\n    border-radius: ", "px;\n    box-shadow: -1px 2px 2px 0px #00000040;\n    box-sizing: border-box;\n    margin-left: ", ";\n    padding: 0.3rem ", ";\n    text-overflow: ellipsis;\n    text-align: center;\n    overflow: hidden;\n    text-wrap: nowrap;\n    display: inline-block;\n    background: ", ";\n    &:hover {\n      background: ", ";\n      color: ", ";\n      box-shadow: unset;\n      cursor: pointer;\n    }\n  "])), radii[0], space[1], space[6], colors.secondary, colors.primary, colors.secondary);
}, space);
var FormSuggestions = function (_a) {
    var labels = _a.labels, possibleSelectValues = _a.possibleSelectValues, onClick = _a.onClick, props = __rest(_a, ["labels", "possibleSelectValues", "onClick"]);
    return (React.createElement(SuggestionsContainer, { "data-component": "FormSuggestions" }, labels.map(function (label, idx) {
        if (!possibleSelectValues) {
            return (React.createElement(StyledWrapper, __assign({ onClick: function () { return onClick(label); }, key: idx }, props), label));
        }
        else if (possibleSelectValues[label]) {
            return (React.createElement(StyledWrapper, __assign({ onClick: function () { return onClick(possibleSelectValues[label].value); }, key: idx }, props), label));
        }
        return null;
    })));
};
export default FormSuggestions;
var templateObject_1;
//# sourceMappingURL=FormSuggestions.js.map